/* contactFullName — kontakty mají name (křestní) a surname (příjmení) ZVLÁŠŤ.
 * Pro zobrazení uživateli VŽDY skládej celé jméno tímto helperem
 * (jinak poradce vidí jen „Jakub" a neví, který Jakub to je).
 */
export const contactFullName = (c) =>
  [c?.name, c?.surname].filter(Boolean).join(" ").trim() || c?.company || "";
